import React, {useEffect, useState} from "react";
import styles from './toolbar.module.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faFlask, faChevronUp, faChevronDown} from "@fortawesome/free-solid-svg-icons";
import {useTranslation} from "react-i18next";

export default function OperationsToolbar({addOperation, addAction, addTimer, addDelay, saveAction, showSaved, devMode, onTestAll, testAllLoading}) {
    const {t} = useTranslation();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [toolbarOpen, setToolbarOpen] = useState(false);

    useEffect(() => {
        const handler = () => {
            const mobile = window.innerWidth < 768;
            setIsMobile(mobile);
            if (!mobile) setToolbarOpen(true);
        };
        window.addEventListener('resize', handler);
        return () => window.removeEventListener('resize', handler);
    }, []);

    return (
        <div className={styles.container}>
            {isMobile && (
                <div className={styles.toggleHandle} onClick={() => setToolbarOpen(o => !o)}>
                    <FontAwesomeIcon icon={toolbarOpen ? faChevronDown : faChevronUp} size="sm"/>
                </div>
            )}
            <div className={`${styles.toolbarContent}${isMobile && !toolbarOpen ? ' ' + styles.toolbarContentHidden : ''}`}>
                <div className={`${styles.innerContainer}`}>
                    <div className={`${styles.normalButton} me-3`} onClick={addOperation}>{t('operations.toolbar.addOperation')}</div>
                    <div className={`${styles.normalButton} me-3`} onClick={addTimer}>{t('operations.toolbar.addTimer')}</div>
                    <div className={`${styles.normalButton} me-3`} onClick={addDelay}>{t('operations.toolbar.addDelay')}</div>
                    <div className={styles.normalButton} onClick={addAction}>{t('operations.toolbar.addAction')}</div>
                    {devMode && (
                        <div className={styles.normalButton}
                             onClick={testAllLoading ? undefined : onTestAll}
                             style={{backgroundColor: '#FEF3C7', color: '#92400E', opacity: testAllLoading ? 0.6 : 1}}>
                            <FontAwesomeIcon icon={faFlask} className="me-2"/>
                            {testAllLoading ? t('operations.toolbar.testing') : t('operations.toolbar.testAll')}
                        </div>
                    )}
                </div>
                <div className={'d-flex align-items-center'}>
                    {showSaved && <FontAwesomeIcon icon={faCheck} color={'#47b947'} className={'pe-3'} size={'xl'}/>}
                    <div className={styles.saveButton} onClick={saveAction}>{t('operations.toolbar.saveChanges')}</div>
                </div>
            </div>
        </div>
    );
}
